import axios from "axios";

const BASE_PATH = process.env.VUE_APP_IMOKS_API_URL;

class UserApi {
  static checkSession = async () => {
    const path = `/checksession`;
    try {
      await axios.get(BASE_PATH.concat(path));
      return true;
    } catch {
      return false;
    }
  };
  static getUserInfo = async () => {
    const path = `/user/info`;
    return (await axios.get(BASE_PATH.concat(path))).data;
  };
}

export default UserApi;
